import {
  WhmBox,
  WhmButton,
  WhmMenuItem,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { Translate } from "../../../Translation/Translate";
import { translationKeys } from "../../../../contexts/I18nContext";
import { useState } from "react";
import { ReactComponent as RightChevron } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-right.svg";
import { ReactComponent as PlusIcon } from "@securitize/assets-sec-ui/dist/icons/svg/add.svg";
import { ReactComponent as DecreaseIcon } from "@securitize/assets-sec-ui/dist/icons/svg/decrease.svg";
import { ReactComponent as IncreaseIcon } from "@securitize/assets-sec-ui/dist/icons/svg/increase.svg";
import { ReactComponent as AddEntityIcon } from "@securitize/assets-sec-ui/dist/icons/svg/entity.svg";
import { ReactComponent as AddIndividualIcon } from "@securitize/assets-sec-ui/dist/icons/svg/profile-add.svg";
import FlexMenu from "../../../shared/FlexMenu";

export const AddMemberButton = ({
  onAddIndividualClick,
  onAddEntityClick,
}: {
  onAddIndividualClick: () => void;
  onAddEntityClick: () => void;
}) => {
  const [menuOrigin, setMenuOrigin] = useState<null | HTMLElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <WhmButton
        data-test-id="add-member-button"
        onClick={(e) => {
          setMenuOpen(true);
          setMenuOrigin(e.currentTarget);
        }}
        variant="contained"
        sx={{ whiteSpace: "nowrap" }}
      >
        <WhmStack direction={"row"} alignItems="center" gap="8px">
          <PlusIcon fill="currentColor" />
          <Translate
            translationKey={
              translationKeys.PROFILE_KEY_PARTIES_NO_KEY_PARTIES_ADD_MEMBER
            }
          />
          {menuOpen ? (
            <IncreaseIcon fill="currentColor" />
          ) : (
            <DecreaseIcon fill="currentColor" />
          )}
        </WhmStack>
      </WhmButton>
      <FlexMenu
        onClose={() => setMenuOpen(false)}
        open={menuOpen}
        anchorEl={menuOrigin}
      >
        <WhmMenuItem
          data-test-id="add-individual-menu-item"
          onClick={() => {
            onAddIndividualClick();
            setMenuOpen(false);
          }}
        >
          <WhmStack direction="row" alignItems="center" gap="12px" width="100%">
            <AddIndividualIcon fill={whmTheme.palette.text.secondary} />
            <WhmStack>
              <WhmTypography variant="body2">
                <Translate
                  translationKey={
                    translationKeys.PROFILE_KEY_PARTIES_INDIVIDUAL
                  }
                />
              </WhmTypography>
              <WhmTypography
                variant="body2"
                color="text.secondary"
                whiteSpace="normal"
              >
                <Translate
                  translationKey={
                    translationKeys.PROFILE_KEY_PARTIES_INDIVIDUAL_DETAIL
                  }
                />
              </WhmTypography>
            </WhmStack>
            <WhmBox marginLeft="auto">
              <RightChevron fill={whmTheme.palette.text.secondary} />
            </WhmBox>
          </WhmStack>
        </WhmMenuItem>
        <WhmMenuItem
          data-test-id="add-entity-menu-item"
          onClick={() => {
            onAddEntityClick();
            setMenuOpen(false);
          }}
        >
          <WhmStack direction="row" alignItems="center" gap="12px" width="100%">
            <AddEntityIcon fill={whmTheme.palette.text.secondary} />
            <WhmStack>
              <WhmTypography variant="body2">
                <Translate
                  translationKey={translationKeys.PROFILE_KEY_PARTIES_ENTITY}
                />
              </WhmTypography>
              <WhmTypography
                variant="body2"
                color="text.secondary"
                whiteSpace="normal"
              >
                <Translate
                  translationKey={
                    translationKeys.PROFILE_KEY_PARTIES_ENTITY_DETAIL
                  }
                />
              </WhmTypography>
            </WhmStack>
            <WhmBox marginLeft="auto">
              <RightChevron fill={whmTheme.palette.text.secondary} />
            </WhmBox>
          </WhmStack>
        </WhmMenuItem>
      </FlexMenu>
    </>
  );
};
